import React from "react";

import WComponent from "../../../common/WComponent";
import ToolsModal from "../kit/ToolsModal";
import TrialBalanceImportPanel from "./TrialBalanceImportPanel";

class TrialBalanceImportModal extends WComponent {
	render() {
		const { clientId, wpfEngagementId, currentImport, onImported, onCleared, onClose } = this.props;

		const footer = (
			<>
				<span />
				<span className="tk-modal-actions">
					<button type="button" className="tk-button tk-button--secondary" onClick={onClose}>Close</button>
				</span>
			</>
		);

		return (
			<ToolsModal open={true} onClose={onClose} title="Read a trial balance" width={720} footer={footer}>
				<TrialBalanceImportPanel
					clientId={clientId}
					wpfEngagementId={wpfEngagementId}
					currentImport={currentImport}
					onImported={onImported}
					onCleared={onCleared}
				/>
			</ToolsModal>
		);
	}
}

export default TrialBalanceImportModal;
